<template>
    <div class="content">
        <div class="container-fluid">

            <div class="row">
                <div class="col-md-4">
                    <card>
                        <h4 slot="header" class="card-title">Настройки</h4>
                        <form>
                            <div class="row">
                                <div class="loader" v-if="waiting"></div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Версия</label>
                                        <select v-model="status" id="status-filter"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="1" selected>Production</option>
                                            <option value="">Dev</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <button type="submit" class="btn btn-info btn-fill btn-filter"
                                            @click.prevent="get()">
                                        Фильтровать
                                    </button>
                                    <button type="submit" class="btn btn-success btn-fill float-right btn-save btn-filter"
                                            @click.prevent="save()">
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label class="control-label">Список категорий</label>
                                        <draggable v-model="data">
                                            <transition-group>
                                                <div class="category-list" v-for="element in data" :key="element.id">
                                                    {{ element.name }}
                                                </div>
                                            </transition-group>
                                        </draggable>
                                    </div>
                                </div>

                            </div>


                        </form>
                    </card>
                </div>

                <div class="card col-xl-8 col-md-8">
                    <div class="loader" v-if="waiting"></div>
                    <div class="app-area">

                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Категория</label>
                                <select v-model="categoryId" id="category-filter"
                                        @change="showTemplates(categoryId)"
                                        aria-describedby="addon-right addon-left" class="form-control">
                                    <option v-for="c in data" v-bind:value="c.id">{{ c.name }}</option>
                                </select>
                            </div>
                        </div>

                        <div v-for="(itm, i) in data" :key="i">
                            <div v-if="data[i].id === categoryId">
                                <p v-if="data[i].templates.length > 0" class="category-name">{{ data[i].name }}</p>

                                <div v-if="data[i].templates.length > 0" class="scrolling-wrapper">

                                    <draggable v-model="data[i].templates">
                                        <div v-for="(itm, j) in data[i].templates" class="inline-div"
                                             @click.prevent="openVideo(data[i].templates[j].src_full)">
                                            <div class="card-template" :key="j"
                                                 v-if="!isVideo(data[i].templates[j].preview_src_full)"
                                                 v-bind:style="{ 'background-image': 'url(' + data[i].templates[j].preview_src_full + ')' }">

                                            </div>
                                            <div class="card-template"
                                                 @click.prevent="openVideo(data[i].templates[j].src_full)"
                                                 v-if="isVideo(data[i].templates[j].preview_src_full)">
                                                <video muted loop autoplay playsinline
                                                       :key="getTemplateSrc(data[i].templates[j].preview_src_full)"
                                                       style="max-width: 100%; cursor: pointer;">
                                                    <source :src="getTemplateSrc(data[i].templates[j].preview_src_full)"
                                                            :type="getTemplateType()"/>
                                                </video>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix"></div>
                        <div class="video-bg" v-if="activeVideo" @click.prevent="closeVideo()"></div>
                        <div id="player" v-if="activeVideo">
                            <video onloadstart="this.volume=0.1" controls autoplay id="video_player"
                                   style="max-width: 100%;">
                                <source v-bind:src="activeVideo"/>
                            </video>
                            <button type="button" class="btn btn-fill btn-close"
                                    @click.prevent="closeVideo()"
                                    v-bind:class="{ 'active-state': activeVideo }">
                                Закрыть
                            </button>
                        </div>

                    </div>
                    <span class="after"></span>
                </div>


            </div>

        </div>
    </div>
</template>
<script>
const _ = require('lodash')
const axios = require('axios')
import Card from 'src/components/UIComponents/Cards/Card.vue'
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
        Card
    },
    created: function () {
        this.get();
    },
    data() {
        return {
            data: [],
            activeVideo: "",
            status: "1",
            waiting: false,
            categoryId: 998,
            categories: [
                {
                    id: 1,
                    name: '11',
                },
                {
                    id: 2,
                    name: '22',
                },
                {
                    id: 3,
                    name: '33',
                },
                {
                    id: 4,
                    name: '44',
                }

            ]
        }
    },
    methods: {
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(
                `${this.$hostname}/admin/templates/preview`,
                {
                    'params': {
                        status: this.status,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.waiting = false;
                    self.data = response.data;
                })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error)
                })

        },
        save: function () {
            let self = this;

            let token = localStorage.getItem('token');

            self.waiting = true;

            axios.post(
                `${this.$hostname}/admin/templates/preview/resort`,
                {
                    data: this.data
                },
                {
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.waiting = false;
                    console.log(response);
                })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error)
                })

        },
        getTemplateSrc: function(src) {
            return src;
        },
        getTemplateType: function() {
            return 'video/mp4';
        },
        showTemplates: function(categoryId) {
            console.log(categoryId);
        },
        isVideo: function (url) {
            return url.indexOf('.mp4') > -1;
        },
        openVideo: function (src) {
            this.activeVideo = src;
        },
        closeVideo: function () {
            this.activeVideo = "";
        },
    }
}
</script>
<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

html, body {
    -webkit-touch-callout: none;
}

html, body {
    margin: 0;
    max-height: 100%;
    overflow: hidden;
    position: fixed
}

.category-name {
    margin-left: 10pt;
    font-family: 'SF Pro Display', sans-serif !important;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.5px;
    margin-bottom: 12px;
}

.app-area {
    width: 100%;
    overflow: scroll;
    background: #fff;
    padding: 15px 0 0;
}

.category-list {
    width: 200px;
    height: 40px;
    border: 1px solid #000;
    border-radius: 5px;
    margin-bottom: 10px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
}

.category-list.sortable-chosen {
    background-color: #000;
    color: #fff;

}

.btn-filter {
    margin-top: 25px;
}

.btn-close {
    display: none;
    width: 283px;
    height: 40px;
    margin: 33px auto;
    background: #000;
    border: none;
    -webkit-animation: .07s ease 0s normal forwards 1 fadein;
    animation: .07s ease 0s normal forwards 1 fadein;
    font-size: 15px;
}

.btn-close.active-state {
    display: block;
}

.btn-close:hover {
    background: #000;
    opacity: 0.8 !important;
}


@keyframes fadein {
    0% {
        opacity: 0;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-webkit-keyframes fadein {
    0% {
        opacity: 0;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.inline-div {
    display: inline-block;
    position: relative;
}

*::-webkit-scrollbar {
    display: none;
}

.card {
    position: relative;
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.iphone-x .before {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
    width: 56%;
    height: 30px;
    background-color: #1f1f1f;
    border-radius: 0px 0px 40px 40px;
    z-index: 99;
}

h2 {
    color: #fff;
}

.scrolling-wrapper {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    padding-left: 8px;
}

.scrolling-wrapper .card-template {
    display: inline-block;
}

.card-template {
    width: 105px;
    height: 186px;
    background-size: cover;
    border: none;
    border-radius: 8px;
    margin-left: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.premium {
    width: 18px;
    height: 18px;
    position: absolute;
    top: -166px;
    right: 12px;
}

.timer {
    width: 15px;
    height: 15px;
    position: absolute;
    top: -166px;
    left: 12px;
}

.scrolling-wrapper {
    height: 186px;
    margin-bottom: 30px;
    width: 100%;
    -webkit-overflow-scrolling: touch;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.video-bg {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #000000;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10;
    opacity: 0.7;
}


#player {
    width: 324px;
    height: 700px;
    position: absolute;
    top: 0;
    background: #fff;
    z-index: 11;
    transition: all .3s ease-out;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Preview.vue